import CategoryIcon from '@material-ui/icons/Category';
import {
  coreExtensionData,
  createExtensionInput,
  createFrontendModule,
  FrontendModule,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { convertLegacyRouteRef } from '@backstage/core-compat-api';
import { catalogPlugin, CatalogTable } from '@backstage/plugin-catalog';
import { CatalogIndexPage } from '@backstage/plugin-catalog/alpha';
import { crossplaneReadyColumn } from '../components/catalog/columns';

// Override da page:catalog do catalog/alpha para reintroduzir a coluna "Ready"
// (crossplane) na listagem de Resources, como no EntityPage legado. A página
// alpha (CatalogIndexPage) aceita `columns`; mantemos o input `filters` (filtros
// declarativos, incluindo o CrossplaneReadyFilter) e o routeRef do catalog para
// não quebrar os bindings.
const catalogPageWithReadyColumn = PageBlueprint.makeWithOverrides({
  inputs: {
    filters: createExtensionInput([coreExtensionData.reactElement]),
  },
  factory(originalFactory, { inputs }) {
    return originalFactory({
      path: '/catalog',
      routeRef: convertLegacyRouteRef(catalogPlugin.routes.catalogIndex),
      title: 'Catalog',
      icon: <CategoryIcon fontSize="inherit" />,
      loader: async () => {
        const filters = inputs.filters.map(filter =>
          filter.get(coreExtensionData.reactElement),
        );
        return (
          <CatalogIndexPage
            filters={<>{filters}</>}
            columns={context => {
              const defaults = CatalogTable.defaultColumnsFunc(context);
              if (context.filters?.kind?.value === 'resource') {
                return [...defaults, crossplaneReadyColumn];
              }
              return defaults;
            }}
          />
        );
      },
    });
  },
});

export const catalogPageModule: FrontendModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [catalogPageWithReadyColumn],
});

export default catalogPageModule;
